import { BlogSection } from '@/types/blog';

export const referenzen: BlogSection = {
  id: 'referenzen',
  title: 'Wissenschaftliche Quellen',
  content: `
<p class="text-sm">Aron, E. N. (1997). The Highly Sensitive Person: How to Thrive When the World Overwhelms You. Broadway Books.</p>

<p class="text-sm">Aron, E. N. und Aron, A. (1997). Sensory-Processing Sensitivity and Its Relation to Introversion and Emotionality. Journal of Personality and Social Psychology, 73(2), 345–368.</p>

<p class="text-sm">Acevedo, B. P., Aron, E. N., Aron, A., Sangster, M. D., Collins, N. und Brown, L. L. (2014). The highly sensitive brain: An fMRI study of sensory processing sensitivity and response to others' emotions. Brain and Behavior, 4(4), 580–594.</p>

<p class="text-sm">Edmondson, A. C. (1999). Psychological Safety and Learning Behavior in Work Teams. Administrative Science Quarterly, 44(2), 350–383.</p>

<p class="text-sm">Edmondson, A. C. (2019). The Fearless Organization: Creating Psychological Safety in the Workplace for Learning, Innovation, and Growth. Wiley.</p>

<p class="text-sm">Duhigg, C. (2016). What Google Learned From Its Quest to Build the Perfect Team. The New York Times Magazine.</p>

<p class="text-sm">Greven, C. U., Lionetti, F., Booth, C., Aron, E. N., Fox, E., Schendan, H. E. und Homberg, J. (2019). Sensory Processing Sensitivity in the context of Environmental Sensitivity: A critical review and development of research agenda. Neuroscience and Biobehavioral Reviews, 98, 287–305.</p>
  `
};
